Vue.component('ack-downloadables', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-downloadables',
	mixins: [languageMixins],
	created() {
		if (this.isUS_CA) {
			this.usCaFlyerLinkHandler(
				'sol-plus',
				'https://cdn.ackuretta.com/downloads/sol-plus/US_Digital_SOL%20Plus_Flyer.pdf',
			);
			this.usCaFlyerLinkHandler(
				'sol',
				'https://cdn.ackuretta.com/downloads/sol/US_Digital_SOL_Flyer.pdf',
			);
		}

		this.setDownloadablesData();
	},
	mounted() {
		appLog.log('ack-downloadables mounted');
		this.setPageIsLoading(false);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		...Vuex.mapGetters('localization', ['isUS_CA']),
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'downloadables-page',
			CATEGORIES: [
				'Flyers',
				'Certifications',
				'Guides & Manuals',
				'Firmware Updates',
				'Instructions For Use',
				'Resins Safety Sheets',
				'Comparisons',
				'Others',
			],
			GROUPING_TYPES: { product: 'Product', category: 'Category' },
			searchKeyword: '',
			filteredDownloadables: [],
			downloadables: [
				//ALPHA AI
				{
					id: 'alpha-ai',
					title: 'ALPHA AI',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/alpha-ai/Global_Digital_ALPHA%20AI_Flyer.pdf',
						},
						{
							title: 'Download ALPHA AI & Upgrade to Premium',
							link: '/pages/video-gallery?videoId=VoLbCy4sE-4',
						},
					],
				},
				//Rodin Brochure
				{
					id: 'rodin-brochure',
					title: 'Rodin Brochure',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin-Brochure__2025Dec_final.pdf?v=1780908934',
						},
					],
				},
				//Rodin Instructions For Use
				{
					id: 'rodin-instructions-for-use',
					title: 'Rodin Instructions For Use',
					downloads: [
						{
							title: 'Rodin Bond Instructions for Use',
							categoryTitle: 'Rodin Bond Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Bond_Instructions_for_Use.pdf?v=1780909366',
						},
						{
							title: 'Rodin Glaze N2-Free Instructions for Use',
							categoryTitle: 'Rodin Glaze N2-Free Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Glaze_N2-Free_Instructions_for_Use.pdf?v=1780909370',
						},
						{
							title: 'Rodin Titan Instructions for Use',
							categoryTitle: 'Rodin Titan Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Instructions_for_Use.pdf?v=1780909371',
						},
						{
							title: 'Rodin Flexisplint Instructions for Use',
							categoryTitle: 'Rodin Flexisplint Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint_Instructions_for_Use.pdf?v=1780909371',
						},
						{
							title: 'Rodin Surgical Guide 2.0 Instructions for Use',
							categoryTitle: 'Rodin Surgical Guide 2.0 Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Surgical_Guide_2.0_Instructions_for_Use.pdf?v=1780909371',
						},
						{
							title: 'Rodin SensiGuard Instructions for Use',
							categoryTitle: 'Rodin SensiGuard Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_SensiGuard_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin Try-In Instructions for Use',
							categoryTitle: 'Rodin Try-In Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Try-In_Instructions_for_Use.pdf?v=1780909372',
						},
						{
							title: 'Rodin Splint 2.0 Instructions for Use',
							categoryTitle: 'Rodin Splint 2.0 Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint_2.0_Instructions_for_Use.pdf?v=1780909372',
						},
						{
							title: 'Rodin Castable Resin Instructions for Use',
							categoryTitle: 'Rodin Castable Resin Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Castable_Resin_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin RapidCeram Instructions for Use',
							categoryTitle: 'Rodin RapidCeram Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin Bite Tray Instructions for Use',
							categoryTitle: 'Rodin Bite Tray Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Bite_Tray_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin Denture Base 2.0 Instructions for Use',
							categoryTitle: 'Rodin Denture Base 2.0 Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Base_2.0_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin Ortho IBT Instructions for Use',
							categoryTitle: 'Rodin Ortho IBT Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Ortho_IBT_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin Resin Cleaner Instructions for Use',
							categoryTitle: 'Rodin Resin Cleaner Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin EnVision Instructions for Use',
							categoryTitle: 'Rodin EnVision Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin TruModel Instructions for Use',
							categoryTitle: 'Rodin TruModel Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_TruModel_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin Sculpture 2.0 Instructions for Use',
							categoryTitle: 'Rodin Sculpture 2.0 Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin Luting Cement Instructions for Use',
							categoryTitle: 'Rodin Luting Cement Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Instructions_for_Use.pdf?v=1780909373',
						},
						{
							title: 'Rodin BioArch RPD Instructions for Use',
							categoryTitle: 'Rodin BioArch RPD Instructions for Use',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_BioArch_RPD_Instructions_for_Use.pdf?v=1780909377',
						},
					],
				},
				//Rodin Safety Data Sheets
				{
					id: 'rodin-safety-data-sheets',
					title: 'Rodin Safety Data Sheets',
					materialSafetyDataSheet: [
						{
							title: 'Rodin Sculpture 2.0 Safety Data Sheet',
							categoryTitle: 'Rodin Sculpture 2.0 Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Resin Cleaner Safety Data Sheet',
							categoryTitle: 'Rodin Resin Cleaner Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin RapidCeram Safety Data Sheet',
							categoryTitle: 'Rodin RapidCeram Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Titan Safety Data Sheet',
							categoryTitle: 'Rodin Titan Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Denture Base 2.0 Safety Data Sheet',
							categoryTitle: 'Rodin Denture Base 2.0 Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Base_2.0_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Try-In Safety Data Sheet',
							categoryTitle: 'Rodin Try-In Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Try-In_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Surgical Guide 2.0 Safety Data Sheet',
							categoryTitle: 'Rodin Surgical Guide 2.0 Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Surgical_Guide_2.0_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Ortho IBT Safety Data Sheet',
							categoryTitle: 'Rodin Ortho IBT Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Ortho_IBT_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Castable Resin Safety Data Sheet',
							categoryTitle: 'Rodin Castable Resin Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Castable_Resin_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Flexisplint Safety Data Sheet',
							categoryTitle: 'Rodin Flexisplint Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Envision Safety Data Sheet',
							categoryTitle: 'Rodin Envision Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Envision_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Luting Cement Safety Data Sheet',
							categoryTitle: 'Rodin Luting Cement Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Bite Tray Safety Data Sheet',
							categoryTitle: 'Rodin Bite Tray Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Bite_Tray_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin TruModel Safety Data Sheet',
							categoryTitle: 'Rodin TruModel Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_TruModel_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin BioArch RPD Safety Data Sheet',
							categoryTitle: 'Rodin BioArch RPD Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_BioArch_RPD_Safety_Data_Sheet.pdf?v=1780910960',
						},
						{
							title: 'Rodin Splint 2.0 Safety Data Sheet',
							categoryTitle: 'Rodin Splint 2.0 Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint_2.0_Safety_Data_Sheet.pdf?v=1780910961',
						},
						{
							title: 'Rodin N2-Free Palette Naturalizing Kit Safety Data Sheet',
							categoryTitle: 'Rodin N2-Free Palette Naturalizing Kit Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_N2-Free_Palette_Naturalizing_Kit_Safety_Data_Sheet.pdf?v=1780910961',
						},
						{
							title: 'Rodin Glaze N2-Free Safety Data Sheet',
							categoryTitle: 'Rodin Glaze N2-Free Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Glaze_N2-Free_Safety_Data_Sheet.pdf?v=1780910961',
						},
						{
							title: 'Rodin SensiGuard Safety Data Sheet',
							categoryTitle: 'Rodin SensiGuard Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_SensiGuard_Safety_Data_Sheet.pdf?v=1780910961',
						},
						{
							title: 'Rodin Bond Safety Data Sheet',
							categoryTitle: 'Rodin Bond Safety Data Sheet',
							link: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Bond_Safety_Data_Sheet.pdf?v=1780910961',
						},
					],
				},
				//SOL SE
				{
					id: 'sol-se',
					title: 'SOL SE',
					downloads: [
						{
							title: 'SOL SE_Essential User Guide Digital',
							link: 'https://cdn.ackuretta.com/downloads/sol-se/SOL%20SE_Essential%20User%20Guide_Print.pdf',
						},
						{
							title: 'SOL SE Flyer',
							link: 'https://cdn.ackuretta.com/downloads/sol-se/SOL%20SE_Flyer.pdf',
						},
						{
							title: 'SOL SE with CS Essential User Guide Digital',
							link: 'https://cdn.ackuretta.com/downloads/sol-se/SOL_SE_with_CS_Essential_User_Guide_Print.pdf?_gl=1*77cc9y*_gcl_au*Mzg2MTc5MTM4LjE3NzYyMjE0ODE.*FPAU*Mzg2MTc5MTM4LjE3NzYyMjE0ODE',
						},
					],
				},
				//SOL Plus
				{
					id: 'sol-plus',
					title: 'SOL Plus',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/Global_Digital_SOL%20Plus_Flyer.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus_QSG.pdf',
						},
						{
							title: 'Quick Start Guide with Concierge Service',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus%20with%20Concierge%20Service_QSG.pdf',
						},
						{
							title: 'Firmware Update',
							link: 'https://go.ackuretta.com/sol-plus-updating-firmware',
						},
						{
							title: 'Compatible Materials',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus%20Compatible%20Resins.pdf',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL%20Plus_FAQ.pdf',
						},
						{
							title: 'CE Certification',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/CE_SOL%20Plus.pdf',
						},
						{
							title: 'Compare Printers',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
						},
						{
							title: 'Ackuretta Catalog',
							link: 'https://cdn.ackuretta.com/downloads/sol-plus/SOL_PLUS_Ackuretta_Catalog.pdf',
						},
					],
				},
				//SOL
				{
					id: 'sol',
					title: 'SOL',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/sol/Global_Digital_SOL_Flyer.pdf',
						},
						{
							title: 'Brochure',
							link: 'https://cdn.ackuretta.com/downloads/sol/Global_Digital_SOL_Brochure.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_QSG.pdf',
						},
						{
							title: 'Quick Start Guide with Concierge Service',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL%20with%20Concierge%20Service_QSG_Website.pdf',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'User Manual',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL%20User%20Manual.pdf',
						},
						{
							title: 'Firmware Update',
							link: 'https://go.ackuretta.com/sol-firmware-update',
						},
						{
							title: 'Compatible Materials',
							link: 'https://go.ackuretta.com/sol-compatible-materials/downloads',
						},
						{
							title: 'Compare Printers',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_FAQ.pdf',
						},
						{
							title: 'CE Certification',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_CE.pdf',
						},
						{
							title: 'FCC Certification',
							link: 'https://cdn.ackuretta.com/downloads/sol/FCC_SOL.pdf',
						},
						{
							title: 'Ackuretta Catalog',
							link: 'https://cdn.ackuretta.com/downloads/sol/SOL_Ackuretta_Catalog.pdf',
						},
					],
				},
				//DENTIQ
				{
					id: 'dentiq',
					title: 'DENTIQ',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/Global_Digital_DENTIQ%20Flyer.pdf',
						},
						{
							title: 'Brochure',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/Global_Digital_DENTIQ_Brochure.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/DENTIQ_QSG.pdf',
						},
						{
							title: 'User Manual',
							link: 'https://drive.google.com/file/d/1tqJ-7uMY9hSnPTHoKLyJRDcSUOC_tnH6/view?usp=sharing',
						},
						{
							title: 'Firmware Update',
							link: 'https://go.ackuretta.com/dentiq-firmware-update',
						},
						{
							title: 'Compatible Materials',
							link: 'https://go.ackuretta.com/dentiq-compatible-materials/downloads',
						},
						{
							title: 'Compare Printers',
							link: 'https://cdn.ackuretta.com/downloads/3dps/Ackuretta%20Printers%20Comparison_1.pdf',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/DENTIQ_FAQ.pdf',
						},
						{
							title: 'CE Certification',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/PRO-OTH-190422-0013_DENTIQ%20120%20FreeShape%20120%20Veribuild%2079200%20CE%20Declaration%20of%20Conformity%20-%20ACKURETTA.pdf',
						},
						{
							title: 'FCC Certification',
							link: 'https://cdn.ackuretta.com/downloads/dentiq/PRO-OTH-210910-0033_DENTIQ%20FCC%20Certificate.pdf.pdf',
						},
					],
				},
				//CLEANI Tank Plus
				{
					id: 'cleani-tank-plus',
					title: 'CLEANI with Tank Plus',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/cleani/Global_Digital_CLEANI_Flyer.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/cleani-tank-plus/CLEANI%20with%20Tank%20Plus_QSG.pdf?v=latest',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/cleani-tank-plus/CLEANI%20Tank%20Plus_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI_FAQ.pdf',
						},
					],
				},
				//CLEANI Dual Tanks
				{
					id: 'cleani-dual-tanks',
					title: 'CLEANI with Dual Tanks',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/cleani/Global_Digital_CLEANI_Flyer.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI%20with%20Dual%20Tanks_QSG.pdf?v=latest',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI%20Dual%20Tanks_Technical%20Specifications%20Sheet.pdf?v=latest',
						},
						{
							title: 'FAQs',
							link: 'https://cdn.ackuretta.com/downloads/cleani/CLEANI_FAQ.pdf',
						},
					],
				},
				//CURIE Plus & nfinity
				{
					id: 'curie-plus-nfinity',
					title: 'CURIE Plus & NFinity',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/Web_CURIE%20Plus%20Flyer.pdf',
						},
						{
							title: 'CURIE PLUS FAQ & Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_QSG.pdf?v=latest',
						},
						{
							title: 'NFinity FAQ & Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/Nfinity_QSG.pdf?v=latest',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'Firmware Update',
							link: 'https://go.ackuretta.com/curie-plus-firmware',
						},
						{
							title: 'How to Cure with Nitrogen',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_SOP.pdf?v=latest',
						},
						{
							title: 'Compatible Materials',
							link: 'https://cdn.ackuretta.com/downloads/curie-plus/CURIE%20Plus_Compatible_resins.pdf',
						},
						{
							title: 'Compare UV Ovens',
							link: 'https://cdn.ackuretta.com/downloads/3dps/uv_ovens_comparison.pdf',
						},
					],
				},
				//CURIE
				{
					id: 'curie',
					title: 'CURIE',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/curie/Global_Digital_CURIE_Flyer.pdf',
						},
						{
							title: 'Quick Start Guide',
							link: 'https://cdn.ackuretta.com/downloads/curie/CURIE%2024_11_2022.pdf',
						},
						{
							title: 'User Manual',
							link: 'https://cdn.ackuretta.com/downloads/curie/CURIE%20User%20Manual.pdf',
						},
						{
							title: 'Technical Specifications',
							link: 'https://cdn.ackuretta.com/downloads/curie/CURIE_Technical%20Specifications%20Sheet.pdf',
						},
						{
							title: 'Resin Library update',
							link: window.ackShopifyFileUrl('CURIE_Resin_Profile_Library_Update_Guide.pdf'),
						},
						{
							title: 'Curing Values',
							link: 'https://cdn.ackuretta.com/downloads/curie/Post%20curing%20settings.pdf?v=2',
						},
						{
							title: 'Compare UV Ovens',
							link: 'https://cdn.ackuretta.com/downloads/3dps/uv_ovens_comparison.pdf',
						},
						{
							title: 'CE Certification',
							link: 'https://cdn.ackuretta.com/downloads/curie/CE%20document_curie2.pdf',
						},
					],
				},
				//CURO
				{
					id: 'curo',
					title: 'CURO',
					downloads: [
						{
							title: 'Brochure',
							link: 'https://cdn.ackuretta.com/downloads/curo/Global_Digital_CURO_Brochure.pdf?v=latest',
						},
						{
							title: 'Instructions for Use',
							link: 'https://cdn.ackuretta.com/downloads/curo/Instructions%20for%20Use.pdf',
						},
						{
							title: 'Application Booklet',
							link: 'https://go.ackuretta.com/application-booklet',
						},
						{
							title: 'Curing times',
							link: 'https://cdn.ackuretta.com/downloads/curo/CURO%20Resins%20Post%20Curing%20Times.pdf',
						},
					],
					materialSafetyDataSheet: [
						{
							title: 'Material Safety Data Sheet',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20ProGingiva%20-%20PRO-TD-241129-001%20-%20MSDS.pdf',
						},
						{
							title: 'Ortho Model',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Ortho%20Model%20-%20MSDS.pdf',
						},
						{
							title: 'Splint',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Pro%20Splint-%20MSDS.pdf',
						},
						{
							title: 'Gingiva',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Gingiva-%20MSDS.pdf',
						},
						{
							title: 'Crown',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Crown%20-%20MSDS.pdf',
						},
						{
							title: 'ProCast',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Pro%20Cast%20-%20MSDS.pdf',
						},
						{
							title: 'ProDenture',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Pro%20Denture%20-%20MSDS.pdf',
						},
						{
							title: 'IBT',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20IBT%20-%20MSDS.pdf',
						},
						{
							title: 'Guide',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Guide%20-%20MSDS.pdf',
						},
						{
							title: 'Tray',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Tray%20-%20MSDS.pdf',
						},
						{
							title: 'Model',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Model%20-%20MSDS.pdf',
						},
						{
							title: 'Element Model White',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Element%20Model%20White-%20MSDS.pdf',
						},
						{
							title: 'Element Model Beige',
							link: 'https://cdn.ackuretta.com/downloads/curo/material-safety-data-sheet/CURO%20Element%20Model%20Beige-%20MSDS.pdf',
						},
					],
				},
				{
					id: 'flow',
					title: 'FLOW',
					downloads: [
						{
							title: 'Flyer',
							link: 'https://cdn.ackuretta.com/downloads/flow/Global_Digital_FLOW_Flyer.pdf?v=latest',
						},
						{
							title: 'C&B Instructions for Use',
							link: 'https://cdn.ackuretta.com/downloads/flow/IFU/FLOW_C&B_IFU.pdf',
						},
						{
							title: 'Denture Instructions for Use',
							link: 'https://cdn.ackuretta.com/downloads/flow/IFU/FLOW_Denture_IFU.pdf',
						},
						{
							title: 'Hard Splint Instructions for Use',
							link: 'https://cdn.ackuretta.com/downloads/flow/IFU/FLOW_Hard%20Splint_IFU.pdf',
						},
					],
					materialSafetyDataSheet: [
						// {
						// 	title: 'Material Safety Data Sheet',
						// 	link: '',
						// },
						{
							title: 'C&B',
							link: 'https://cdn.ackuretta.com/downloads/flow/MSDS/MSDS%20-%20FLOW%20C&B.pdf',
						},
						{
							title: 'Denture',
							link: 'https://cdn.ackuretta.com/downloads/flow/MSDS/MSDS%20-%20FLOW%20Denture.pdf',
						},
						{
							title: 'Hard Splint',
							link: 'https://cdn.ackuretta.com/downloads/flow/MSDS/MSDS%20-%20FLOW%20Hard%20Splint.pdf',
						},
					],
				},
			],
			categorizeDownloadables: {},

			selectedGroupingType: 'Product',
			selectedCategory: '',
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		setDownloadablesData() {
			this.filteredDownloadables = this.downloadables;
			this.categorizeDownloadables = this.categorizeDownloads();
		},

		onSearchByCategoryClick(searchCategory) {
			this.selectedCategory = searchCategory;
			if (this.selectedGroupingType !== this.GROUPING_TYPES.category) {
				this.selectedGroupingType = this.GROUPING_TYPES.category;
				return;
			}
			this.filteredDownloadables = {
				[this.selectedCategory]: this.categorizeDownloadables[this.selectedCategory],
			};
		},
		onResetAllClick() {
			document.querySelectorAll('.accordion-item').forEach((accordionItem) => {
				accordionItem.querySelector('.accordion-button').classList.remove('collapsed');
				accordionItem.querySelector('.accordion-collapse').classList.add('show');
			});
			this.searchKeyword = '';
			this.filteredDownloadables = this.downloadables;
			this.selectedGroupingType = this.GROUPING_TYPES.product;
			this.selectedCategory = '';
		},

		getLinkCategory(linkTitle) {
			const keywordMap = [
				{ keywords: ['Flyer'], category: 'Flyers' },
				{
					keywords: ['CE Certification', 'FCC Certification', 'Certification'],
					category: 'Certifications',
				},
				{
					keywords: ['Quick Start Guide', 'User Manual', 'Brochure', 'SOP'],
					category: 'Guides & Manuals',
				},
				{ keywords: ['Firmware Update'], category: 'Firmware Updates' },
				{
					keywords: ['Instructions for Use', 'Instructions_for_Use', 'IFU'],
					category: 'Instructions For Use',
				},
				{
					keywords: [
						'Material Safety Data Sheet',
						'Safety Data Sheet',
						'Safety_Data_Sheet',
						'MSDS',
					],
					category: 'Resins Safety Sheets',
				},
				{ keywords: ['Compare', 'Comparison'], category: 'Comparisons' },
			];
			for (const map of keywordMap) {
				if (map.keywords.some((keyword) => this.hasKeywordMatch(linkTitle, keyword))) {
					return map.category;
				}
			}
			return 'Others';
		},
		categorizeDownloads() {
			const categorized = {};
			this.CATEGORIES.forEach((category) => {
				categorized[category] = {};
				categorized[category].id = category.toLowerCase().replace(/\s+/g, '').replace(/&/g, '-');
				categorized[category].title = category;
				categorized[category].downloads = [];
				categorized[category].materialSafetyDataSheet = [];
			});

			this.downloadables.forEach((downloadable) => {
				const downloadableLinksDatas = [
					...(downloadable.downloads || []),
					...(downloadable.materialSafetyDataSheet || []),
				];

				downloadableLinksDatas.forEach((downloadableLinkData) => {
					const linkCategory = this.getLinkCategory(downloadableLinkData.title);
					const linkType =
						linkCategory === 'Resins Safety Sheets' ? 'materialSafetyDataSheet' : 'downloads';

					categorized[linkCategory][linkType].push({
						title:
							downloadableLinkData.categoryTitle ||
							downloadable.title + ' ' + downloadableLinkData.title,
						link: downloadableLinkData.link,
						product: downloadable.title,
					});
				});
			});

			return categorized;
		},
		usCaFlyerLinkHandler(productId, link) {
			this.downloadables
				.find((downloadable) => downloadable.id === productId)
				.downloads.find((download) => download.title === 'Flyer').link = link;
		},
		highlightKeyword(targetText) {
			if (!this.searchKeyword) return targetText;
			// Escape regex metacharacters so user input can't build an invalid/catastrophic pattern (ReDoS).
			const escaped = this.searchKeyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			const regex = new RegExp(`(${escaped})`, 'gi');
			return targetText.replace(regex, '<span class="highlight" >$1</span>');
		},
		focusInput() {
			this.$refs.searchInput.focus();
		},
		filterSearchData(downloadables, newKeyword) {
			return downloadables.filter((downloadable) => {
				const formatDownloadable = downloadable.length > 1 ? downloadable[1] : downloadable;

				return (
					this.searchByFileName(formatDownloadable, newKeyword) ||
					this.hasKeywordMatch(formatDownloadable.title, newKeyword)
				);
			});
		},

		searchByFileName(downloadable, searchKeyword) {
			const linksFolders = ['downloads', 'materialSafetyDataSheet'];

			return linksFolders.some((linksFolder) => {
				return downloadable[linksFolder]?.some((link) =>
					this.hasKeywordMatch(link.title, searchKeyword),
				);
			});
		},
		hasKeywordMatch(text, keyword) {
			return text.toLowerCase().includes(keyword.toLowerCase());
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},

		searchKeyword(newKeyword) {
			if (this.selectedGroupingType === this.GROUPING_TYPES.product) {
				this.filteredDownloadables = this.filterSearchData(this.downloadables, newKeyword);
			}
			if (this.selectedGroupingType === this.GROUPING_TYPES.category) {
				this.filteredDownloadables = Object.fromEntries(
					this.filterSearchData(Object.entries(this.categorizeDownloadables), newKeyword),
				);
			}
		},
		selectedGroupingType() {
			if (this.selectedGroupingType === this.GROUPING_TYPES.product) {
				this.filteredDownloadables = this.downloadables;
				this.selectedCategory = '';
			}
			if (this.selectedGroupingType === this.GROUPING_TYPES.category) {
				if (!this.selectedCategory) {
					this.filteredDownloadables = this.categorizeDownloadables;
					return;
				}
				this.filteredDownloadables = {
					[this.selectedCategory]: this.categorizeDownloadables[this.selectedCategory],
				};
			}
		},
	},
});
